module.exports = __webpack_public_path__ + "static/skeleton_2-c05b11ec2a66501bcca772565717874a.jpg";